(function () {
  function revealImmediately(elements) {
    elements.forEach(function (el) {
      el.classList.add('is-revealed');
    });
  }
 
  function initScrollReveal() {
    var elements = document.querySelectorAll('[data-reveal]:not(.is-revealed)');
    if (elements.length === 0) return;
 
    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var animationsEnabled = document.body.dataset.animationsEnabled !== 'false';
 
    if (prefersReducedMotion || !animationsEnabled || !('IntersectionObserver' in window)) {
      revealImmediately(elements);
      return;
    }
 
    var observer = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-revealed');
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -8% 0px' }
    );
 
    elements.forEach(function (el) {
      observer.observe(el);
    });
  }
 
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initScrollReveal);
  } else {
    initScrollReveal();
  }
 
  // Detecta secciones agregadas/reordenadas dinámicamente en el editor de temas
  if ('MutationObserver' in window) {
    var bodyObserver = new MutationObserver(function (mutations) {
      var hasNewNodes = mutations.some(function (mutation) {
        return mutation.addedNodes.length > 0;
      });
      if (hasNewNodes) {
        initScrollReveal();
      }
    });
 
    bodyObserver.observe(document.body, { childList: true, subtree: true });
  }
 
  document.addEventListener('shopify:section:load', initScrollReveal);
})();